import { PurchaseOrderInvoiceDto } from './purchase-order-invoice.dto';

export class ErroredInvoiceResponseDto {
  invoiceNo: string;
  message: string;
}

export class PurchaseOrderInvoiceSaveBulkResponseDto {
  saved: PurchaseOrderInvoiceDto[];
  ignored: PurchaseOrderInvoiceDto[];
  errored: ErroredInvoiceResponseDto[];
}
